import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
function handleBuyClick() {
  if ((window as any).fbq) {
    ;
    (window as any).fbq('track', 'AddToCart', {
      value: 6.36,
      currency: 'USD',
      content_name: 'Escape 9-a-5 PDF'
    });
  }
}
export function CTASection() {
  return <section className="py-24 bg-brand-dark text-white text-center relative overflow-hidden" data-id="element-1">
      {/* Background glow */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-brand-primary/20 pointer-events-none" data-id="element-2"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-3">
        <h2 className="text-4xl md:text-5xl font-heading font-medium mb-8 leading-tight" data-id="element-4">
          ¿Atrapada en el 9-a-5? <br data-id="element-5" />
          <span className="text-brand-secondary italic font-bold" data-id="element-6">
            Tu libertad está a una llamada de distancia.
          </span>
        </h2>

        <p className="text-xl text-rose-100 mb-12 max-w-2xl mx-auto font-light" data-id="element-7">
          No dejes pasar otro año deseando que las cosas cambien. Toma el
          control de tus ingresos, de tu tiempo y de tu vida hoy mismo.
        </p>

        <Button size="lg" href="https://www.betterbysteps.com/cart/44215868555357:1" target="_blank" rel="noopener noreferrer" onClick={handleBuyClick} className="w-full sm:w-auto px-6 sm:px-12 py-4 sm:py-6 text-base sm:text-xl h-auto shadow-rose-500/50 shadow-2xl" data-id="element-8">
          SÍ, QUIERO ESCAPAR — SOLO $6.36
          <ArrowRight className="ml-3 h-5 w-5 shrink-0" data-id="element-9" />
        </Button>

        <p className="mt-4 text-xs text-rose-300/40 italic" data-id="element-10">
          "Menos que un café. El inicio de tu libertad."
        </p>

        <p className="mt-4 text-sm text-rose-300/60 uppercase tracking-widest" data-id="element-11">
          Acceso inmediato al PDF digital
        </p>
      </div>
    </section>;
}